/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
export const NanoAccordion = /*@__PURE__*/ createReactComponent('nano-accordion');
export const NanoAlert = /*@__PURE__*/ createReactComponent('nano-alert');
export const NanoAlgolia = /*@__PURE__*/ createReactComponent('nano-algolia');
export const NanoAlgoliaFilter = /*@__PURE__*/ createReactComponent('nano-algolia-filter');
export const NanoAlgoliaPagination = /*@__PURE__*/ createReactComponent('nano-algolia-pagination');
export const NanoAlgoliaResults = /*@__PURE__*/ createReactComponent('nano-algolia-results');
export const NanoAnimation = /*@__PURE__*/ createReactComponent('nano-animation');
export const NanoCheckbox = /*@__PURE__*/ createReactComponent('nano-checkbox');
export const NanoCheckboxGroup = /*@__PURE__*/ createReactComponent('nano-checkbox-group');
export const NanoDatalist = /*@__PURE__*/ createReactComponent('nano-datalist');
export const NanoDateInput = /*@__PURE__*/ createReactComponent('nano-date-input');
export const NanoDatePicker = /*@__PURE__*/ createReactComponent('nano-date-picker');
export const NanoDemo = /*@__PURE__*/ createReactComponent('nano-demo');
export const NanoDetails = /*@__PURE__*/ createReactComponent('nano-details');
export const NanoDialog = /*@__PURE__*/ createReactComponent('nano-dialog');
export const NanoDrawer = /*@__PURE__*/ createReactComponent('nano-drawer');
export const NanoDropdown = /*@__PURE__*/ createReactComponent('nano-dropdown');
export const NanoFieldValidator = /*@__PURE__*/ createReactComponent('nano-field-validator');
export const NanoFileUpload = /*@__PURE__*/ createReactComponent('nano-file-upload');
export const NanoGlobalNav = /*@__PURE__*/ createReactComponent('nano-global-nav');
export const NanoGlobalNavUserProfile = /*@__PURE__*/ createReactComponent('nano-global-nav-user-profile');
export const NanoGlobalSearchResults = /*@__PURE__*/ createReactComponent('nano-global-search-results');
export const NanoGrid = /*@__PURE__*/ createReactComponent('nano-grid');
export const NanoGridItem = /*@__PURE__*/ createReactComponent('nano-grid-item');
export const NanoHero = /*@__PURE__*/ createReactComponent('nano-hero');
export const NanoIcon = /*@__PURE__*/ createReactComponent('nano-icon');
export const NanoIconButton = /*@__PURE__*/ createReactComponent('nano-icon-button');
export const NanoImg = /*@__PURE__*/ createReactComponent('nano-img');
export const NanoInput = /*@__PURE__*/ createReactComponent('nano-input');
export const NanoIntersectionObserve = /*@__PURE__*/ createReactComponent('nano-intersection-observe');
export const NanoMenu = /*@__PURE__*/ createReactComponent('nano-menu');
export const NanoMenuDrawer = /*@__PURE__*/ createReactComponent('nano-menu-drawer');
export const NanoMoreLess = /*@__PURE__*/ createReactComponent('nano-more-less');
export const NanoNavItem = /*@__PURE__*/ createReactComponent('nano-nav-item');
export const NanoOption = /*@__PURE__*/ createReactComponent('nano-option');
export const NanoOverflowNav = /*@__PURE__*/ createReactComponent('nano-overflow-nav');
export const NanoProgressBar = /*@__PURE__*/ createReactComponent('nano-progress-bar');
export const NanoRange = /*@__PURE__*/ createReactComponent('nano-range');
export const NanoRating = /*@__PURE__*/ createReactComponent('nano-rating');
export const NanoResizeObserve = /*@__PURE__*/ createReactComponent('nano-resize-observe');
export const NanoSelect = /*@__PURE__*/ createReactComponent('nano-select');
export const NanoSkeleton = /*@__PURE__*/ createReactComponent('nano-skeleton');
export const NanoSlide = /*@__PURE__*/ createReactComponent('nano-slide');
export const NanoSlides = /*@__PURE__*/ createReactComponent('nano-slides');
export const NanoSortable = /*@__PURE__*/ createReactComponent('nano-sortable');
export const NanoSpinner = /*@__PURE__*/ createReactComponent('nano-spinner');
export const NanoSplitPane = /*@__PURE__*/ createReactComponent('nano-split-pane');
export const NanoSticker = /*@__PURE__*/ createReactComponent('nano-sticker');
export const NanoTab = /*@__PURE__*/ createReactComponent('nano-tab');
export const NanoTabContent = /*@__PURE__*/ createReactComponent('nano-tab-content');
export const NanoTabGroup = /*@__PURE__*/ createReactComponent('nano-tab-group');
export const NanoTable = /*@__PURE__*/ createReactComponent('nano-table');
export const NanoTooltip = /*@__PURE__*/ createReactComponent('nano-tooltip');
//# sourceMappingURL=components.js.map